// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1Y9xF","boxTitle":"Qualiphy_boxTitle__mHTUo","box":"Qualiphy_box__2BwIw","toggleWrap":"Qualiphy_toggleWrap__uL0D3"};